import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EnumTranslatePipe } from "app/shared/localization/enum-translate.pipe";
import { SharedModule } from "app/shared/shared.module";
import { MessageModule } from "primeng/message";
import { MessagesModule } from "primeng/messages";
import { DefaultLayoutComponent } from "./components/default-layout/default-layout.component";
import { AppMenuComponent } from "./components/menu/menu.component";
import { CoreRoutingModule } from "./core-routing.module";
import { SideBarService } from "./services/side-bar.service";
import { coreReducer } from "./state/state.index";
import { PermissionsService } from "./permissions/permissions.service";
import { PermissionsGuard } from "./permissions/permissions.guard";
import { AppBreadcrumbComponent } from "./components/breadcrumb/app.breadcrumb.component";
import { AppTopBarComponent } from "./components/topbar/app.topbar.component";
import { AppMenuitemComponent } from "./components/menu/menu-item.component";
import { AppBreadcrumbService } from "./components/breadcrumb/app.breadcrumb.service";
import { MenuService } from "./components/menu/menu.service";
import { CouponService } from "./services/coupon.service";
import { MyRoulettesComponent } from './components/web-roulette/my-roulettes/my-roulettes.component';
import { SideMenuComponent } from "./components/side-menu/side-menu.component";
import { ProfileComponent } from "./components/web-roulette/profile/profile/profile.component";
import { ProfileDetailsComponent } from './components/web-roulette/profile/profile-details/profile-details.component';
import { ProfilePaymentsComponent } from './components/web-roulette/profile/profile-payments/profile-payments.component';
import { ProfileService } from "./services/profile.service";
import { LidsComponent } from "./components/web-roulette/lids/lids/lids.component";
import { LidCardMobileComponent } from './components/web-roulette/lids/lids-mobile/lid-card-mobile/lid-card-mobile.component';
import { LidsMobileComponent } from "./components/web-roulette/lids/lids-mobile/lids-mobile/lids-mobile.component";
import { LidDetailsDialogComponent } from './components/web-roulette/lids/lid-details-dialog/lid-details-dialog.component';
import { AtnExportExcelComponent } from "./components/atn-export-excel/atn-export-excel.component";
import { CouponsComponent } from './components/coupons/coupons/coupons.component';
import { ViewingCouponsComponent } from './components/coupons/viewing-coupons/viewing-coupons.component';
import { CouponRedemptionComponent } from "./components/coupons/coupon-redemption/coupon-redemption.component";
import { PaymentCardMobileComponent } from './components/web-roulette/profile/payments-mobile/payment-card-mobile/payment-card-mobile/payment-card-mobile.component';
import { PaymentsMobileComponent } from './components/web-roulette/profile/payments-mobile/payments-mobile/payments-mobile.component';
import { BusinessCouponsComponent } from "./components/web-roulette/Business-Cupons/business-coupons/business-coupons.component";
import { LoginModule } from "../login/login.module";
import { BusinessManagementComponent } from "./components/web-roulette/business-management/business-management.component";
import { BusinessManagmentService } from "./services/business-managment.service";

@NgModule({
  exports: [
  ],
  imports: [
    CommonModule, CoreRoutingModule, SharedModule,
    MessageModule,
    MessagesModule,
    StoreModule.forFeature('core', coreReducer),
    LoginModule
],
  declarations: [
    AppMenuComponent,
    DefaultLayoutComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppMenuitemComponent,
    CouponRedemptionComponent,
    MyRoulettesComponent,
    ProfileComponent,
    LidsComponent,
    SideMenuComponent,
    ProfileDetailsComponent,
    ProfilePaymentsComponent,
    LidsMobileComponent,
    LidCardMobileComponent,
    LidDetailsDialogComponent,
    AtnExportExcelComponent,
    CouponsComponent,
    ViewingCouponsComponent,
    PaymentCardMobileComponent,
    PaymentsMobileComponent,
    BusinessCouponsComponent,
   BusinessManagementComponent
  ],
  providers: [EnumTranslatePipe, SideBarService, PermissionsService, CouponService,ProfileService,
    PermissionsGuard, AppBreadcrumbService, MenuService,BusinessManagmentService]


})
export class CoreModule { }
